import React, { useEffect, useState, Suspense } from "react";
import Loader from "../components/commons/Loader";
import HomePageLayout from "../layout/HomePageLayout";

// Dynamically import components
const Banner = React.lazy(() => import("../components/banner"));
const Faqs = React.lazy(() => import("../components/faqs"));
const HealthPrioritizeHomePage = React.lazy(() =>
  import("../components/healthPrioritize/HealthPrioritizeHomePage")
);
const HealthServiceHomePage = React.lazy(() =>
  import("../components/healthService/HealthServiceHomePage")
);
const HelpMatchDifferent = React.lazy(() =>
  import("../components/helpMatchDifferent")
);
const HelpMatchSlider = React.lazy(() =>
  import("../components/helpMatchSlider")
);
const HelpMatchHomePageWork = React.lazy(() =>
  import("../components/helpMatchWork/HelpMatchHomePageWork")
);
const HomePageHealthProvider = React.lazy(() =>
  import("../components/homeHealthProvider/HomePageHealthProvider")
);
const ProfessionalCategories = React.lazy(() =>
  import("../components/professionalCategories")
);
const UseHelpMatchHomePage = React.lazy(() =>
  import("../components/useHelpMatch/UseHelpMatchHomePage")
);

const HomePage = () => {
  const [selectedProfessionId, setSelectedProfessionId] = useState(null);
  const [isReady, setIsReady] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 50) {
      setIsReady(true);
    }
  };
    const handleMouse = () => {
      setIsReady(true);
    };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    localStorage.removeItem("adminName");
    localStorage.removeItem("isImpersonate");
    const gclid = sessionStorage.getItem('gclid')
    if(gclid){
      sessionStorage.removeItem('gclid')
    }
    
    return () =>{
      window.removeEventListener("scroll", handleScroll)
     }
  }, []);
 

  const handleSelectedProfession = (id) => {
    setSelectedProfessionId(id);
  };

  return (
    <HomePageLayout >
      {/* <Suspense fallback={<Loader isLoading={true}/>}> */}
        <Banner
          onMouseDown={handleMouse}
          selectedProfessionId={selectedProfessionId}
          setSelectedProfessionId={setSelectedProfessionId}
        />
          <HomePageHealthProvider />
        {isReady && (
          <>
            <HelpMatchHomePageWork />
            <UseHelpMatchHomePage title="Why Use HelpMatch?" test="true" />
            <HelpMatchDifferent
              title="What Sets HelpMatch Apart?"
              itemDetail="With HelpMatch, finding the right healthcare provider is simple, fast, and reliable. We’re here to connect you with trusted professionals who meet our high standards for qualifications, experience, and patient satisfaction."
            />
            <Faqs title="Frequently Asked Questions" />
            <ProfessionalCategories
              title="Browse by Popular Provider Services"
              selectedProfession={handleSelectedProfession}
            />
            <HealthPrioritizeHomePage title="Prioritizing Your Health" />
            <HelpMatchSlider title="What Others Are Saying" />
            <HealthServiceHomePage
              title="Get Matched with Your Perfect Healthcare Provider In Minutes!"
              itemDetail="Get scheduled with your perfect healthcare provider match now. Click the 'Get Matched Now' button to get matched with a uniquely qualified provider who can help you today."
            />
          </>
        )}
      {/* </Suspense> */}
    </HomePageLayout>
  );
};

export default HomePage;
